import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useState } from "react";
import Login from "./pages/auth/Login";
import SignUp from "./pages/auth/SignUp";
import Home from "./pages/home/Home";
import Renew from "./pages/renewal/Renew";
import RenewInfo from "./pages/renewal/RenewInfo";
import RenewWrapper from "./pages/renewal/RenewWrapper";
import History from "./pages/history/History";
import CreditHistory from "./pages/history/CreditHistory";
import DebitHistory from "./pages/history/DebitHistory";
import AllHistory from "./pages/history/AllHistory";
import Customers from "./pages/customers/Customers";
import PublicRoute from "./middleware/PublicRoute";
import PrivateRoute from "./middleware/PrivateRoute";
import RequireRole from "./middleware/RequireRole";
import { useSelector } from "react-redux";
import DistributorHome from "./pages/home/DistributorHome";
import DistributorCustomers from "./pages/customers/DistributorCustomers";
import DistributorCredit from "./pages/history/DistributorCredit";
import DistributorDebit from "./pages/history/DistributorDebit";
import RenewCart from "./pages/renewal/RenewCart";
import OrderDetails from "./pages/history/OrderDetails";
import CustomerInfo from "./pages/customers/CustomerInfo";
import TermsAndCondition from "./pages/terms/TermsAndCondition";
import PrivacyPolicy from "./pages/terms/PrivacyPolicy";
import SoldPins from "./pages/history/SoldPins";
import BoughtPins from "./pages/history/BoughtPins";
import DistributorPinList from "./pages/pins/DistributorPinList";
import FixedAgentPins from "./pages/pins/FixedAgentPins";
import ExportedPins from "./pages/history/ExportedPins";
import ActiveSoldPins from "./pages/history/ActiveSoldPins";
import UsedSoldPins from "./pages/history/UsedSoldPins";
import RequestReset from "./pages/auth/RequestReset";
import ResetPassword from "./pages/auth/ResetPassword";
import EditRenewal from "./pages/renewal/EditRenewal";
import UpdateConfirmation from "./pages/cei/UpdateConfirmation";
import InsuranceSync from "./pages/insurance-sync/InsuranceSync";
import UpdateProfile from "./pages/profile/UpdateProfile";
import VerifierDashboard from "./pages/verifier/VerifierDashboard";
import Rewards from "./pages/rewards/Rewards";

function App() {
  const [showMenu, setShowMenu] = useState(false);

  const accountType = useSelector(
    (state) => state.userData.loginData.account_type,
  );

  // useEffect(() => {
  //   const fetchSalamMeta = async () => {
  //     console.log("[Salam Meta] Effect triggered", {
  //       hasToken: Boolean(token),
  //       loading: salamMeta.loading,
  //       hasData: Boolean(salamMeta.data),
  //       lastFetched: salamMeta.lastFetched,
  //     });

  //     if (!token || salamMeta.loading || salamMeta.data) {
  //       console.log("[Salam Meta] Skipping fetch", {
  //         reason: !token
  //           ? "missing token"
  //           : salamMeta.loading
  //             ? "already loading"
  //             : "data already exists",
  //       });
  //       return;
  //     }

  //     try {
  //       dispatch(userDataActions.setSalamMetaLoading(true));
  //       console.log("[Salam Meta] Fetching metadata from endpoint...");
  //       const response = await FixedAgent.getSalamMetadata({ token });
  //       const salamData = response.data?.data || {};
  //       console.log("[Salam Meta] Raw response received", {
  //         vehicleMakesCount: salamData.vehicle_makes?.length || 0,
  //         colorsCount: salamData.colors?.length || 0,
  //         statesCount: salamData.states?.length || 0,
  //         sampleMake: salamData.vehicle_makes?.[0],
  //         sampleColor: salamData.colors?.[0],
  //       });

  //       dispatch(
  //         userDataActions.setSalamMetaData({
  //           makes: salamData.vehicle_makes || [],
  //           colors: (salamData.colors || []).map((color) => ({
  //             ...color,
  //             vehicleColorId: color.id,
  //             colorName: color.name,
  //           })),
  //           states: salamData.states || [],
  //         }),
  //       );
  //       console.log("[Salam Meta] Metadata stored in Redux");
  //     } catch (error) {
  //       console.error("[Salam Meta] Fetch failed", {
  //         message: error?.response?.data?.message || error?.message,
  //         response: error?.response?.data,
  //       });
  //       dispatch(
  //         userDataActions.setSalamMetaError(
  //           error?.response?.data?.message ||
  //             error?.message ||
  //             "Failed to load Salam metadata",
  //         ),
  //       );
  //     }
  //   };

  //   fetchSalamMeta();
  // }, [dispatch, salamMeta.data, salamMeta.loading, token]);

  const router = createBrowserRouter([
    {
      path: "/login",
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: "/register",
      element: <SignUp />,
    },
    {
      path: "/request-password-reset",
      element: <RequestReset />,
    },
    {
      path: "/password-reset",
      element: <ResetPassword />,
    },
    {
      path: "/",
      element: (
        <PrivateRoute>
          {accountType === "DISTRIBUTOR" ? (
            <DistributorHome showMenu={showMenu} setShowMenu={setShowMenu} />
          ) : accountType === "VERIFIER" ? (
            <VerifierDashboard />
          ) : (
            <Home showMenu={showMenu} setShowMenu={setShowMenu} />
          )}
        </PrivateRoute>
      ),
    },

    {
      path: "/history/:id",
      element: (
        <PrivateRoute>
          <OrderDetails showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },

    {
      path: "/customers",
      element: (
        <PrivateRoute>
          {accountType === "DISTRIBUTOR" ? (
            <DistributorCustomers
              showMenu={showMenu}
              setShowMenu={setShowMenu}
            />
          ) : (
            <Customers showMenu={showMenu} setShowMenu={setShowMenu} />
          )}
        </PrivateRoute>
      ),
    },

    {
      path: "/pins",
      element: (
        <PrivateRoute>
          <RequireRole allowedRoles={["DISTRIBUTOR"]}>
            <DistributorPinList showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
    },
    {
      path: "/fixed-agent/pins",
      element: (
        <PrivateRoute>
          <RequireRole deniedRoles={["DISTRIBUTOR"]}>
            <FixedAgentPins showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
    },
    {
      path: "/pin",
      element: (
        <PrivateRoute>
          <RequireRole deniedRoles={["DISTRIBUTOR"]}>
            <FixedAgentPins showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
    },

    {
      path: "/add-customer",
      element: (
        <PrivateRoute>
          <RequireRole deniedRoles={["DISTRIBUTOR"]}>
            <CustomerInfo showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
    },
    {
      path: "/terms",
      element: (
        <PrivateRoute>
          <TermsAndCondition showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },
    {
      path: "/privacy",
      element: (
        <PrivateRoute>
          <PrivacyPolicy showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },
    {
      path: "/history",
      element: (
        <PrivateRoute>
          <History showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
      children: [
        {
          path: "/history",
          element: <AllHistory showMenu={showMenu} setShowMenu={setShowMenu} />,
        },

        {
          path: "credit",
          element:
            accountType === "DISTRIBUTOR" ? (
              <DistributorCredit
                showMenu={showMenu}
                setShowMenu={setShowMenu}
              />
            ) : (
              <CreditHistory showMenu={showMenu} setShowMenu={setShowMenu} />
            ),
        },
        {
          path: "debit",
          element:
            accountType === "DISTRIBUTOR" ? (
              <DistributorDebit showMenu={showMenu} setShowMenu={setShowMenu} />
            ) : (
              <DebitHistory showMenu={showMenu} setShowMenu={setShowMenu} />
            ),
        },
      ],
    },

    {
      path: "/pin-history",
      element: (
        <PrivateRoute>
          <History showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
      children: [
        {
          path: "/pin-history",
          element: <AllHistory showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "sold-pins",
          element: <SoldPins showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "active-sold-pins",
          element: (
            <RequireRole allowedRoles={["DISTRIBUTOR"]}>
              <ActiveSoldPins showMenu={showMenu} setShowMenu={setShowMenu} />
            </RequireRole>
          ),
        },
        {
          path: "exported-pins",
          element: (
            <ExportedPins showMenu={showMenu} setShowMenu={setShowMenu} />
          ),
        },
        {
          path: "bought-pins",
          element: <BoughtPins showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "used-sold-pins",
          element: (
            <RequireRole allowedRoles={["DISTRIBUTOR"]}>
              <UsedSoldPins showMenu={showMenu} setShowMenu={setShowMenu} />
            </RequireRole>
          ),
        },
      ],
    },
    {
      path: "/renew",
      element: (
        <PrivateRoute>
          <RequireRole deniedRoles={["DISTRIBUTOR"]}>
            <RenewWrapper showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
      children: [
        {
          path: "/renew",
          element: <Renew showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "info",
          element: <RenewInfo showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "cart",
          element: <RenewCart showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
      ],
    },

    {
      path: "/insurance-sync",
      element: (
        <PrivateRoute>
          <RequireRole allowedRoles={["DISTRIBUTOR"]}>
            <InsuranceSync showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
    },

    {
      path: "/rewards",
      element: (
        <PrivateRoute>
          <RequireRole deniedRoles={["DISTRIBUTOR", "VERIFIER"]}>
            <Rewards showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
    },
    {
      path: "/update-profile",
      element: (
        <PrivateRoute>
          <UpdateProfile showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },
    {
      path: "/cei/update",
      element: <UpdateConfirmation />,
    },

    {
      path: "/edit-order/:id",
      element: (
        <PrivateRoute>
          <RequireRole deniedRoles={["DISTRIBUTOR"]}>
            <EditRenewal showMenu={showMenu} setShowMenu={setShowMenu} />
          </RequireRole>
        </PrivateRoute>
      ),
    },
  ]);

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
